import React from "react";
import EarlyAccessButton from "../EarlyAccessButton";
import styles from "./styles.module.scss";

interface BrowserUseSectionProps {
  onDownloadClick: () => void;
}

/**
 * BrowserUseSection 组件
 * 展示端到端网页自动化功能
 */
const BrowserUseSection = ({ onDownloadClick }: BrowserUseSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {/* 左侧部分 - 文本内容 */}
        <div className={styles.textContentSection}>
          <div className={styles.textContentInner}>
            <h2 className={styles.mainTitle}>
              <div className={styles.titleLine}>
                Fellou is for{" "}
                <span className={styles.highlight}>
                  Getting
                  <br /> Things Done.
                </span>
              </div>
            </h2>

            <div className={styles.browserComparisonText}>
              <div className={styles.browserComparisonLine}>Turn your ideas into a step-by-step plan, </div>
              <div className={styles.browserComparisonLine}>then watch it execute.</div>
            </div>

            <EarlyAccessButton onClick={onDownloadClick} />
          </div>
        </div>

        {/* 右侧部分 - 视频展示（替代动画演示） */}
        <div className={styles.videoSection}>
          <div className={styles.videoContainer}>
            <video autoPlay muted loop playsInline className={styles.videoElement}>
              <source
                src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Browse+USE.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowserUseSection;
